module.exports = __webpack_public_path__ + "static/media/headphone.7d0d8b29.png";